import { render, staticRenderFns } from "./RegularProject.vue?vue&type=template&id=784fda1d&scoped=true"
import script from "./RegularProject.vue?vue&type=script&lang=js"
export * from "./RegularProject.vue?vue&type=script&lang=js"
import style0 from "./RegularProject.vue?vue&type=style&index=0&id=784fda1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784fda1d",
  null
  
)

export default component.exports